module.exports = __webpack_public_path__ + "img/shield-zeus.05e47788.jpg";